import { User } from "@/generated/client";
import { createSlice } from "@reduxjs/toolkit";

interface UserSlice {
  user: User;
}

const initialState = {
  groups: {},
  messages: {}
};

const EdiSlice = createSlice({
  name: "edi",
  initialState,
  reducers: {
    setMessages: (state, action) => {
        state.messages = action.payload;
    },
    setGroups: (state, action) => {
        state.groups = action.payload
    }
  },
});

export const { setMessages, setGroups } = EdiSlice.actions;
export default EdiSlice.reducer;
